"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportedLngs = void 0;
var i18next_1 = __importDefault(require("i18next"));
var react_i18next_1 = require("react-i18next");
var i18next_browser_languagedetector_1 = __importDefault(require("i18next-browser-languagedetector"));
var ru_json_1 = __importDefault(require("./ru.json"));
var hy_json_1 = __importDefault(require("./hy.json"));
var en_json_1 = __importDefault(require("./en.json"));
var detectOptions = {
    order: [
        "querystring",
        "cookie",
        "localStorage",
        "sessionStorage",
        "navigator",
        "htmlTag",
        "path",
        "subdomain",
    ],
    lookupCookie: "locale",
    caches: ["cookie"],
};
exports.supportedLngs = ["en", "ru", "hy"];
i18next_1.default.use(i18next_browser_languagedetector_1.default)
    .use(react_i18next_1.initReactI18next)
    .init({
    detection: detectOptions,
    debug: true,
    fallbackLng: "en",
    supportedLngs: exports.supportedLngs,
    interpolation: {
        escapeValue: false,
    },
    resources: {
        ru: {
            translation: ru_json_1.default,
        },
        hy: {
            translation: hy_json_1.default,
        },
        en: {
            translation: en_json_1.default,
        },
    },
});
exports.default = i18next_1.default;
